/**
 * Utility functions for FaceTec match level calculations and display formatting
 */

/**
 * Convert match level to FAR (False Acceptance Rate) display string
 */
export const getMatchLevelFAR = (matchLevel: number): string => {
  const farMap: Record<number, string> = {
    6: "1:100,000 FAR",
    7: "1:300,000 FAR", 
    8: "1:1,000,000 FAR",
    9: "1:2,000,000 FAR"
  };
  return farMap[matchLevel] || "1:5,000,000 FAR";
};

/**
 * Get color classes for match level badge based on security level
 */
export const getMatchLevelColor = (matchLevel: number): string => {
  if (matchLevel >= 9) return "bg-green-100 text-green-800 border-green-200";
  if (matchLevel >= 8) return "bg-blue-100 text-blue-800 border-blue-200";
  if (matchLevel >= 6) return "bg-yellow-100 text-yellow-800 border-yellow-200";
  return "bg-gray-100 text-gray-800 border-gray-200";
};

/**
 * Get security level description for match level
 */
export const getMatchLevelDescription = (matchLevel: number): string => {
  if (matchLevel >= 9) return "Excellent Security";
  if (matchLevel >= 8) return "Good Security";
  if (matchLevel >= 6) return "Moderate Security";
  return "Basic Security";
};

/**
 * Check if match level indicates high security (level 8+)
 */
export const isHighSecurityMatch = (matchLevel: number): boolean => {
  return matchLevel >= 8;
};

/**
 * Check if match level indicates possible imposter risk (level < 6)
 */
export const isPossibleImposterMatch = (matchLevel: number): boolean => {
  return matchLevel < 6;
};
